import { useState } from "react";
import { useDocumentData } from "react-firebase-hooks/firestore";
import { doc, setDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

function NewsletterSignupPage() {
  const [pageData, loading, error] = useDocumentData(doc(db, "pages", "newsletter"));
  const [email, setEmail] = useState("");
  const [formError, setFormError] = useState("");
  const [success, setSuccess] = useState("");

  // Log for debugging
  console.log("Newsletter render, pageData:", pageData, "error:", error?.message);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError("");
    setSuccess("");

    // Validate email
    if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setFormError("Please enter a valid email address.");
      console.log("Newsletter signup failed: Invalid email", email);
      return;
    }

    try {
      console.log("Attempting to save subscriber email:", email);
      const subscriberRef = doc(collection(db, "subscribers"));
      await setDoc(subscriberRef, {
        email: email.trim(),
        status: "confirmed", // Single opt-in
        subscribedAt: serverTimestamp(),
        userId: null // No auth required for signup
      });
      console.log("Subscriber saved successfully, ID:", subscriberRef.id);
      setSuccess("Thank you for signing up! You'll receive updates soon.");
      setEmail("");
    } catch (err) {
      console.error("Newsletter signup error:", err);
      setFormError("Failed to sign up: " + err.message);
    }
  };

  if (loading) {
    return (
      <div className="container mx-auto px-4 py-16">
        <div className="flex justify-center items-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary" aria-label="Loading" />
        </div>
      </div>
    );
  }

  const title = pageData?.title || "Join Our Newsletter";
  const description = pageData?.description || "Stay updated with tips, insights, and news from 66 Days Journal. Subscribe to our newsletter!";

  return (
    <div className="container mx-auto px-4 py-16">
      <h1 className="text-4xl font-bold text-text-light dark:text-text-dark mb-6">
        {title}
      </h1>
      <p className="text-lg text-neutral mb-8">{description}</p>
      {error && (
        <p className="text-error mb-4 text-center">Error loading content: {error.message}</p>
      )}
      <div className="card bg-background-light dark:bg-background-dark p-6 rounded-md shadow-md max-w-md mx-auto">
        {formError && (
          <p className="text-error mb-4 text-center">{formError}</p>
        )}
        {success && (
          <p className="text-primary mb-4 text-center">{success}</p>
        )}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-text-light dark:text-text-dark font-medium mb-1">
              Email Address
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input w-full"
              placeholder="Enter your email"
              aria-label="Email address"
            />
          </div>
          <button
            type="submit"
            className="btn-primary w-full"
            aria-label="Subscribe to newsletter"
          >
            Subscribe
          </button>
        </form>
      </div>
    </div>
  );
}

export default NewsletterSignupPage;